var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationManButtons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 72h-2V60c0-4.635-3.085-7.641-10.316-10.051a.971.971 0 01-.199-.092l-5-3 1.03-1.714 4.906 2.943C62.836 49.903 69 52.907 69 60v12M13 72h-2V60c0-7.093 6.164-10.097 11.579-11.914l4.906-2.943 1.03 1.714-5 3a.971.971 0 01-.199.092C16.085 52.359 13 55.365 13 60v12M23 72h2v-8h-2zM55 72h2v-8h-2zM33 42h2v-5h-2zM45 42h2v-5h-2zM47 16.171c1.164.413 2 1.525 2 2.829v2c0 .551.448 1 1 1v-9c0-1.654-1.346-3-3-3H36c-1.103 0-2 .897-2 2a1 1 0 01-1 1h-1c-1.103 0-2 .897-2 2v7c.552 0 1-.449 1-1v-2c0-1.654 1.346-3 3-3h7.764l3.789-1.895A1.001 1.001 0 0147 15v1.171zM51 24h-1c-1.654 0-3-1.346-3-3v-2c0-.551-.448-1-1-1a1 1 0 01-1-1v-.382l-2.553 1.277A1.002 1.002 0 0142 18h-8c-.552 0-1 .449-1 1v2c0 1.654-1.346 3-3 3h-1a1 1 0 01-1-1v-8c0-2.206 1.794-4 4-4h.127A4.006 4.006 0 0136 8h11c2.757 0 5 2.243 5 5v10a1 1 0 01-1 1z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 40c-7.794 0-10.832-7.542-10.993-12.579l-.714-.714A.997.997 0 0128 26v-3h2v2.586l.707.707A.997.997 0 0131 27c0 4.253 2.443 11 9 11s9-6.747 9-11c0-.265.105-.52.293-.707l.707-.707V23h2v3c0 .265-.105.52-.293.707l-.714.714C50.832 32.458 47.794 40 40 40M28.999 44.967l6.827 3.792L39 45.586v-.805l-6.841-1.71-3.16 1.896zM36 51a.992.992 0 01-.485-.126l-9-5a.998.998 0 01-.03-1.731l5-3a1 1 0 01.757-.113l8 2A.999.999 0 0141 44v2c0 .265-.105.52-.293.707l-4 4A1 1 0 0136 51z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 45.586l3.174 3.173 6.827-3.792-3.16-1.896L41 44.781v.805zM44 51a1 1 0 01-.707-.293l-4-4A.997.997 0 0139 46v-2a1 1 0 01.758-.97l8-2a.99.99 0 01.757.113l5 3a1.001 1.001 0 01-.03 1.731l-9 5A.992.992 0 0144 51z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M39 58h2v-2h-2zM39 54h2v-2h-2zM39 62h2v-2h-2zM39 66h2v-2h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationManButtons;